// extracted by mini-css-extract-plugin
export default {"container":"CommunicationBoard_container__nsGtc","card":"CommunicationBoard_card__mrYBI","card-on":"CommunicationBoard_card-on__8edZD"};